import type { CityConfig } from "../city-template/types";

export const rioRanchoConfig: CityConfig = {
  city: "Rio Rancho",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "rio-rancho",
  route: "/cities/rio-rancho",
  title: "Emergency Passport Rio Rancho, NM — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rio Rancho, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Intel employees, Sandoval County families, Albuquerque metro professionals, and high-desert community travelers.",
  h1: "Emergency & Expedited Passport Services in Rio Rancho, NM",
  heroSubtitle: "Intel business trip to Penang or Leixlip coming up fast? Family vacation to Mexico booked through ABQ Sunport? UNM or CNM student program starting abroad? We help Rio Rancho residents — from Intel and HP contractors to Enchanted Hills families to Sandoval County professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Rio%20Rancho%20New%20Mexico%20with%20the%20Sandia%20Mountains%20in%20the%20background%20at%20golden%20sunset%2C%20high%20desert%20landscape%20with%20modern%20suburban%20development%2C%20the%20Rio%20Grande%20bosque%20visible%20in%20the%20distance%2C%20dramatic%20New%20Mexico%20sky%20with%20scattered%20clouds%20and%20warm%20earth%20tones%2C%20wide-angle%20landscape%20photography%20with%20rich%20desert%20colors&width=1800&height=700&seq=rio-rancho-hero-2026&orientation=landscape",
  heroImageAlt: "Rio Rancho New Mexico with the Sandia Mountains at golden sunset",
  geoPosition: "35.2855;-106.6700",
  geoPlacename: "Rio Rancho, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "El Paso Passport Agency / Aurora Passport Agency",
    address: "Nearest agencies: El Paso, TX (270 miles) or Aurora, CO (450 miles)",
    distance: "Nearest regional passport agency is in El Paso, TX — approximately 270 miles south. Aurora, CO agency also accessible via I-25. Both require appointments booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Rio Rancho", zips: "87124, 87144, 87174" },
    { name: "Albuquerque (NW)", zips: "87114, 87120, 87121" },
    { name: "Bernalillo", zips: "87004" },
    { name: "Corrales", zips: "87048" },
    { name: "Placitas", zips: "87043" },
    { name: "Los Ranchos", zips: "87107, 87114" },
    { name: "Santa Fe", zips: "87501–87509" },
    { name: "Los Lunas", zips: "87031" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Rio Rancho Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Rio Rancho-area travelers with immediate departures. No driving to El Paso or Aurora required." },
    { icon: "ri-building-2-line", title: "Intel & Tech Industry Ready", desc: "Intel employs over 3,000 people at its Rio Rancho campus. We handle short-notice international business travel for tech professionals heading to Oregon, Israel, Ireland, and Malaysia." },
    { icon: "ri-flight-takeoff-line", title: "ABQ Sunport Convenience", desc: "Just 25 minutes to Albuquerque Sunport. We understand the ABQ schedule and coordinate passport timelines around your Sunport departure." },
    { icon: "ri-home-4-line", title: "Sandoval County Family Service", desc: "Rio Rancho is New Mexico's fastest-growing city for families. We guide first-time passport applicants, renewal families, and multi-passport households through the process." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albuquerque, NM", route: "/cities/albuquerque" },
    { name: "Expedited passport in Santa Fe, NM", route: "/santa-fe" },
    { name: "New Mexico passport services overview", route: "/states/new-mexico" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
  ],
  fpcOfficeAddress: "Serving Rio Rancho via secure registered courier with direct agency access",
  fpcOfficeNote: "Fast Passport Center serves Rio Rancho via secure registered courier with direct access to passport agencies. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Rio Rancho residents can ship from any UPS Store, FedEx Office, or post office location across Sandoval County and the Albuquerque metro.",
  fpcOfficeDistance: "Serving Rio Rancho, Bernalillo, Corrales, Placitas, northwest Albuquerque, and all Sandoval County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rio Rancho and the greater Albuquerque metropolitan area. From the Intel campus area to Enchanted Hills, from the City Center corridor to Loma Colorado — we serve all of Sandoval County and northwest Bernalillo County. Our courier service eliminates the need to drive to a distant passport agency.",
  nearbyCitiesIntro: "We serve Rio Rancho and all surrounding communities including Bernalillo, Corrales, Placitas, northwest Albuquerque, Los Ranchos, Los Lunas, and Santa Fe. We also serve travelers departing from Albuquerque International Sunport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rio Rancho as simple as possible — with the efficiency and reliability Intel professionals, Sandoval County families, and ABQ metro commuters need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Rio Rancho travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Rio Rancho travelers encounter unique passport issues — everything from Intel short-notice business trips to multi-family passport renewals with different expiration dates. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Rio Rancho travelers — from Intel engineers to Sandoval County families to ABQ metro professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Rio Rancho, NM? Here are the most common ones we hear from Sandoval County-area travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before a Sunport flight, an emergency passport for a last-minute Intel business trip, or a first-time passport for a family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.sandovalcountynm.gov/departments/assessor/",
  dmvLabel: "Sandoval County Assessor — Motor Vehicle Information",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Requires travel to El Paso or Aurora — hours of driving"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Intel business trip to Malaysia in two days? Family emergency requiring international travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Rio Rancho-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rio Rancho residents renew fast — no agency visit required for most renewals. Perfect for Intel professionals, Sandoval County families, and ABQ metro commuters.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Rio Rancho residents through every step — from Enchanted Hills to City Center — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your ABQ departure or business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Sandoval County family vacation stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent travel? Ideal for Intel engineers, HP contractors, and Sandoval County professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Rio Rancho travelers through the process so your itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rio Rancho NM", description: "Urgent passport processing for Rio Rancho New Mexico travelers with immediate departure needs from Albuquerque Sunport." },
    { name: "Expedited Passport Renewal Rio Rancho NM", description: "Fast passport renewal for Rio Rancho New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Rio Rancho NM", description: "New passport application services for Rio Rancho New Mexico residents applying for their first passport." },
    { name: "Child Passport Rio Rancho NM", description: "Minor passport services for Rio Rancho New Mexico families with children under 16." },
    { name: "Name Change Passport Rio Rancho NM", description: "Passport name correction after marriage, divorce, or legal name changes for Rio Rancho residents." },
    { name: "Second Passport Rio Rancho NM", description: "Second passport services for Sandoval County tech professionals and frequent travelers." },
  ],
  testimonials: [
    {
      name: "Jennifer T.",
      location: "Rio Rancho (Intel)",
      rating: 5,
      text: "Intel booked me to a facility in Penang with 8 days notice and my passport had expired. Fast Passport Center got it back in 3 days with zero stress. The corporate rush option was perfect — my manager was impressed I had it sorted so fast.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Sandoval Family",
      location: "Enchanted Hills, Rio Rancho",
      rating: 5,
      text: "We booked a cruise departing from Galveston and discovered our three kids' passports all expired within weeks of each other. They handled all four family passports simultaneously — all arrived within 7 days.",
      service: "Family Passport Renewal",
    },
    {
      name: "Mark R.",
      location: "Rio Rancho City Center",
      rating: 5,
      text: "I'm an HP contractor with regular trips to Ireland. My passport needed pages added urgently. They handled it quickly and I never missed a travel cycle. Reliable service I will use again.",
      service: "Passport Pages / Renewal",
    },
    {
      name: "Sarah L.",
      location: "Northern Meadows, Rio Rancho",
      rating: 5,
      text: "My daughter's semester abroad at UNM's exchange program was starting in two weeks and she had no passport yet. They walked us through the first-time application, we visited the Sandoval County Clerk, and the passport was here in 6 days.",
      service: "First-Time Student Passport",
    },
  ],
  facilities: [
    {
      id: "rr-1",
      name: "Rio Rancho Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 Pinetree Rd SE",
      city: "Rio Rancho",
      state: "NM",
      zip: "87124",
      phone: "(505) 892-1640",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Rio Rancho City Center",
      website: "https://tools.usps.com/find-location.htm?location=1376621",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Rio Rancho residents. Passport photos available on-site. Serves the City Center, Enchanted Hills, and Southern Blvd corridor. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "rr-2",
      name: "Bernalillo Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "145 Calle Del Presidente",
      city: "Bernalillo",
      state: "NM",
      zip: "87004",
      phone: "(505) 867-2568",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Bernalillo — Sandoval County seat",
      website: "https://tools.usps.com/find-location.htm?location=1367093",
      websiteLabel: "USPS Location",
      notes: "Serves Bernalillo and northern Rio Rancho residents. Passport photos available. Generally less busy than the Rio Rancho main post office.",
      icon: "ri-mail-line",
    },
    {
      id: "rr-3",
      name: "Sandoval County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1500 Idalia Rd, Building D",
      city: "Bernalillo",
      state: "NM",
      zip: "87004",
      phone: "(505) 867-7575",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Bernalillo — Sandoval County",
      website: "https://www.sandovalcountynm.gov/departments/county-clerk/",
      websiteLabel: "Sandoval County Clerk",
      notes: "Official county clerk passport acceptance facility. No photo services on-site. Serves all Sandoval County residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "rr-4",
      name: "Coronado Station Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11130 Lomas Blvd NE",
      city: "Albuquerque",
      state: "NM",
      zip: "87112",
      phone: "(505) 293-2101",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Albuquerque — convenient for south Rio Rancho",
      website: "https://tools.usps.com/find-location.htm?location=1367428",
      websiteLabel: "USPS Location",
      notes: "Convenient for south Rio Rancho residents commuting to ABQ. Passport photos available. Alternative when Rio Rancho post office is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "rr-5",
      name: "Albuquerque Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1135 Broadway Blvd NE",
      city: "Albuquerque",
      state: "NM",
      zip: "87101",
      phone: "(505) 346-1551",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Albuquerque",
      website: "https://tools.usps.com/find-location.htm?location=1367055",
      websiteLabel: "USPS Location",
      notes: "Largest USPS acceptance facility in the ABQ metro area. Full photo services. Busiest location — book appointments at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "rr-6",
      name: "Los Ranchos Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6700 4th St NW",
      city: "Los Ranchos de Albuquerque",
      state: "NM",
      zip: "87107",
      phone: "(505) 344-3401",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Los Ranchos — north valley",
      website: "https://tools.usps.com/find-location.htm?location=1376535",
      websiteLabel: "USPS Location",
      notes: "Serves Los Ranchos and north valley residents, convenient for south Rio Rancho commuters. Less crowded than Albuquerque main. Call ahead for appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, driving to El Paso or Aurora required", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to El Paso (270 miles) or Aurora (450 miles)", fpc: "Most Rio Rancho travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle shipping, logistics, and travel costs to agency", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "NM-Specific Guidance", agency: "Generic — no Rio Rancho, Intel, or ABQ metro expertise", fpc: "Full Sandoval County/Intel/ABQ metro knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Nearest Agency Is Close By",
      description: "The closest passport agencies to Rio Rancho are 270 miles away in El Paso or 450 miles in Aurora, CO. Many residents assume there is a nearby agency. There is not. Our courier channel bypasses long-distance agency travel entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Rio Rancho applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Rio Rancho pharmacies and big-box stores produce photos that fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Intel Short-Notice Business Travel Documentation Gaps",
      description: "Intel employees often get 1–2 weeks notice for international travel to Penang, Leixlip, or Kiryat Gat. Missing documentation or expired passports at that stage create emergencies we help resolve fast.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Validity Rule",
      description: "Rio Rancho travelers booking to Asia, Europe, or South America often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately during review.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Rio Rancho clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to El Paso, Aurora, or wait at an agency you cannot access locally." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rio Rancho?", a: "We offer Rio Rancho-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Is there a passport agency near Rio Rancho?", a: "No. The closest passport agencies are in El Paso, TX (270 miles) and Aurora, CO (450 miles). Our registered courier service is the fastest legally available channel for Rio Rancho residents — without requiring a day-long drive to an agency." },
    { q: "Where can I get passport acceptance in Rio Rancho?", a: "Rio Rancho has acceptance at the Rio Rancho Post Office on Pinetree Road, the Bernalillo Post Office, and the Sandoval County Clerk office. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "Can you help Intel employees with urgent business travel?", a: "Yes. Intel's Rio Rancho campus is the largest private employer in Sandoval County, and we regularly assist Intel engineers and contractors with short-notice international business travel to Penang, Leixlip, Kiryat Gat, and other Intel sites worldwide." },
    { q: "What documents do Rio Rancho applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Rio Rancho-specific checklist." },
    { q: "How do I get from Rio Rancho to ABQ Sunport for my international flight?", a: "Albuquerque International Sunport is about 25 minutes south of Rio Rancho via I-25 or Coors Blvd. The Sunport has direct flights to Mexico and extensive domestic connections to DFW, LAX, DEN, and PHX for international gateways." },
    { q: "Can I use the same acceptance facility as Albuquerque residents?", a: "Yes. Rio Rancho residents can use any USPS or county clerk acceptance facility in the Albuquerque metro area. Sandoval County Clerk in Bernalillo is often the most convenient option for Rio Rancho residents." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Rio Rancho to final return shipping typically matches your chosen speed tier." },
    { q: "What is the best price for expedited passport service in Rio Rancho?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can you help with passports for the whole family at once?", a: "Yes. Rio Rancho is one of New Mexico's fastest-growing family cities, and we regularly process multiple family members simultaneously. We provide a consolidated family checklist to keep everyone's applications on track." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rio Rancho Residents",
    intro: "Rio Rancho's position as a fast-growing ABQ suburb and home to Intel's largest U.S. manufacturing site creates distinct passport timing challenges. Here's what Rio Rancho travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "ABQ — Albuquerque International Sunport",
        subtitle: "25 minutes from Rio Rancho, NM's primary airport",
        description: "ABQ Sunport is the gateway for virtually all Rio Rancho international travel. With direct flights to Mexico and connections through DFW, LAX, DEN, and PHX to global destinations, the Sunport serves both business and leisure travelers. For Rio Rancho residents, the quick 25-minute drive means passport urgencies need to be resolved before departure day — there are no passport services at the airport.",
        tip: "Check passport validity when you book, not when you pack. Rio Rancho to ABQ is a short drive, but a last-minute passport issue at the gate cannot be fixed at the airport.",
      },
      {
        icon: "ri-building-2-line",
        title: "Intel Rio Rancho Campus — Corporate Travel Hub",
        subtitle: "Largest private employer in Sandoval County",
        description: "Intel's Rio Rancho campus, known as Fab 11X and Fab 9, employs over 3,000 people and is a center for advanced semiconductor manufacturing and packaging technology. International assignments to Intel facilities in Penang (Malaysia), Leixlip (Ireland), Kiryat Gat (Israel), and Chengdu (China) create regular, short-notice passport urgencies. Engineers and technicians often receive 1–3 weeks notice for international travel.",
        tip: "Intel travelers should maintain a current passport at all times — or at minimum keep renewal documents ready. Business travel to Intel international sites rarely allows for standard 8–11 week processing timelines.",
      },
      {
        icon: "ri-home-4-line",
        title: "Family Travel & First-Time Passports",
        subtitle: "New Mexico's fastest-growing city for families",
        description: "Rio Rancho has experienced explosive population growth among families with school-age children. Spring break, summer vacation, and holiday travel create predictable seasonal passport demand. Many Rio Rancho families are first-generation international travelers who need guidance through the entire passport process — from birth certificate requirements to acceptance facility visits.",
        tip: "Apply at least 10 weeks before any planned family international trip. For Rio Rancho families with multiple children needing first-time passports, the acceptance visit alone can take 2–3 hours. We provide a family application coordinator to streamline the process.",
      },
      {
        icon: "ri-car-line",
        title: "Santa Fe Day-Trip Access & Northern NM Connections",
        subtitle: "60 miles to Santa Fe, gateway to northern New Mexico",
        description: "Rio Rancho is conveniently positioned between Albuquerque and Santa Fe. Some residents use Santa Fe for alternative acceptance facilities or combine passport errands with day trips. The Sandoval County Clerk in Bernalillo remains the most convenient local option, but Santa Fe facilities can serve as a backup when Rio Rancho appointments are fully booked.",
        tip: "Santa Fe County Clerk on Grant Avenue accepts passport applications and is an alternative if Sandoval County appointments are unavailable. Call ahead — Santa Fe facilities book up during tourist season.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Rio Rancho & the Albuquerque Metro Ecosystem",
      description: "Rio Rancho is deeply integrated with the Albuquerque metro for services, employment, and transportation. Many Rio Rancho residents work in ABQ, use ABQ post offices and acceptance facilities, and depart from ABQ Sunport. Our service treats the entire Rio Rancho-ABQ corridor as one seamless service area — you choose the facility that works best for you.",
    },
  },
  destinations: {
    title: "Where Rio Rancho Travelers Go — And Why Passports Get Urgent",
    intro: "Rio Rancho's unique mix of high-tech industry, growing families, and ABQ metro access creates distinct international travel patterns. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "45%", label: "of Rio Rancho expedited requests are corporate/tech-related with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time from trip booking to international departure" },
      { stat: "Mar–Jul", label: "peak season — spring break family travel, summer vacation, and Intel Q2-Q3 assignments overlap" },
      { stat: "48 Hours", label: "shortest turnaround for a Rio Rancho Intel engineer departing to Ireland" },
    ],
    destinations: [
      { name: "Mexico", context: "ABQ Sunport direct flights, family heritage trips, Cancun resorts, Puerto Vallarta vacations", urgency: "Spring break bookings peak January through March", icon: "ri-map-pin-2-line" },
      { name: "Ireland", context: "Intel Leixlip campus assignments, corporate training rotations, direct connections via DFW/LHR", urgency: "Intel travel often booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Malaysia", context: "Intel Penang campus, semiconductor industry conferences, technology training", urgency: "Long-haul travel with 2–3 week notice is common for tech assignments", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Germany", context: "Intel/HP supplier meetings, European tech conferences, Sandia Labs coordination", urgency: "Fixed conference and meeting dates are unmovable", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Cruise departures from Galveston or Florida, family resort vacations, spring break", urgency: "Last-minute cruise deals booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Israel", context: "Intel Kiryat Gat campus, technology exchange programs, semiconductor industry travel", urgency: "Tech travel often has rigid scheduling and documentation requirements", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New Mexico Service Areas",
    crossLinksDesc: "We serve travelers across the Land of Enchantment with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albuquerque", route: "/cities/albuquerque" },
      { name: "Santa Fe", route: "/santa-fe" },
      { name: "Las Cruces", route: "/cities/las-cruces" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Rio Rancho", address: "1400 Unser Blvd SE, Rio Rancho, NM 87124", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS Pharmacy — Southern Blvd", address: "4300 Southern Blvd SE, Rio Rancho, NM 87124", hours: "Daily 8 AM – 10 PM" },
    { name: "Walmart — Unser Blvd", address: "901 Unser Blvd SE, Rio Rancho, NM 87124", hours: "Daily 6 AM – 11 PM" },
    { name: "The UPS Store — City Center", address: "2003 Southern Blvd SE, Rio Rancho, NM 87124", hours: "Call for hours" },
    { name: "Walgreens — Enchanted Hills", address: "7800 Enchanted Hills Blvd NE, Rio Rancho, NM 87144", hours: "Daily 8 AM – 10 PM" },
    { name: "FedEx Office — Cottonwood", address: "3701 Ellison Dr NW, Albuquerque, NM 87114", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Sandoval County MVD — Rio Rancho",
      address: "4114 Sabana Grande Ave SE, Rio Rancho, NM 87124",
      hours: "Mon–Fri, 8:00 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Bernalillo",
      address: "435 San Mateo Blvd NE, Albuquerque, NM 87108",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD office. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ABQ",
      name: "Albuquerque International Sunport",
      distance: "About 25–30 minutes from Rio Rancho",
      address: "2200 Sunport Blvd, Albuquerque, NM 87106",
      note: "New Mexico's primary airport. Direct flights to Mexico and extensive domestic connections to DFW, LAX, DEN, PHX, and more for international gateways.",
      flightUrl: "https://www.abqsunport.com/",
      flightLabel: "ABQ Airport Website",
      featured: true,
    },
    {
      code: "SAF",
      name: "Santa Fe Regional Airport",
      distance: "About 55 miles from Rio Rancho",
      address: "121 Aviation Dr, Santa Fe, NM 87507",
      note: "Limited regional service. Serves as an alternative for connections to DFW and DEN for international gateways. About 60 minutes from Rio Rancho.",
      flightUrl: "https://flysantafe.com/",
      flightLabel: "Santa Fe Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for Sandoval County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in Sandoval County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Sandoval County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.sandovalcountynm.gov/departments/county-clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the 13th Judicial District Court. Required for name change passport corrections.",
      url: "https://thirteenthdistrictcourt.nmcourts.gov/",
    },
  ],
};